module.exports = __webpack_public_path__ + "img/41.6.CODm.e252172d.png";